import {createSlice, type SliceSelectors} from '@reduxjs/toolkit'

import {selectAllProduct, selectProduct, confirmPurchase} from '@web/actions/purchaseConfirmation'
import {APIStatus} from '@web/core/constants'
import {getInitialState} from '@web/slices/purchaseConfirmation/slice'

import type {PurchaseConfirmationReducers, MakeSliceOptions} from './interfaces'
import type {PurchaseConfirmationState} from '@web/slices/purchaseConfirmation/slice'

export default (options?: MakeSliceOptions) =>
    createSlice<
        PurchaseConfirmationState,
        PurchaseConfirmationReducers,
        'purchaseConfirmation',
        SliceSelectors<PurchaseConfirmationState>
    >({
        name: 'purchaseConfirmation',
        initialState: getInitialState(),
        reducers: {},
        extraReducers: (builder) => {
            builder
                .addCase(selectAllProduct, (state) => {
                    const isAllChecked = Object.values(state.selectedInfo).every(({checked}) => checked)

                    state.selectedInfo = Object.keys(state.selectedInfo).reduce<{
                        [productOrderNo: string]: {checked: boolean}
                    }>(
                        (prev, productOrderNo) => ({
                            ...prev,
                            [productOrderNo]: {checked: !isAllChecked},
                        }),
                        state.selectedInfo,
                    )
                })
                .addCase(selectProduct, (state, {payload: {productOrderNo, checked}}) => {
                    state.selectedInfo = {
                        ...state.selectedInfo,
                        [productOrderNo]: {checked},
                    }
                })
                .addCase(confirmPurchase.pending, (state) => {
                    state.apiStatus = APIStatus.FETCHING
                })
                .addCase(confirmPurchase.fulfilled, (state) => {
                    state.apiStatus = APIStatus.RESOLVED
                })
                .addCase(confirmPurchase.rejected, (state) => {
                    state.apiStatus = APIStatus.REJECTED
                })
            options?.extraReducers?.(builder)
        },
    })
